import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import queryString from 'query-string';
import Vimeo from 'react-vimeo-embed';

import home_docs_icon from 'assets/img/home_docs_icon.png';
import home_maintenance_icon from 'assets/img/home_maintenance_icon.png';
import home_inventory_icon from 'assets/img/home_inventory_icon.png';
import req_service_icon from 'assets/img/req_service_icon.png';

import * as LotActionType from 'Lots/constants';
import './intro.scss';

class HomeownerIntro extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    homeownerLots: PropTypes.array,
    homeownerDocumentTypes: PropTypes.array,
    location: PropTypes.any,
    history: PropTypes.any
  };

  constructor(props) {
    super(props);

    this.queryParams = queryString.parse(location.search);
    this.lotId = this.queryParams.lotId;

    this.state = {
      rfsUrl: '/'
    };
  }

  componentDidMount() {
    this.getHomeownerLotList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.homeownerLots.length > 1) {
      this.setState({ rfsUrl: '/lots' });
    }
    else if (nextProps.homeownerLots.length > 0) {
      this.setState({ rfsUrl: '/lot/' + nextProps.homeownerLots[0].lot.id + '/request/add' });
    }
  }

  getHomeownerLotList = () => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC
    });
  };

  render() {
    return (
      <div className='box-form-siteone container-fluid' style={{padding: '30px 25px'}}>
        <div className='row'>
          <div className='col-lg-5'>
            <div className='intro-header' style={{marginTop: 0}}>Welcome to HomeHub</div>
            <div className='intro-header-sub'>by SiteOne Services</div>
            <div className='intro-content' style={{marginTop: '20px'}}>
              Your HomeHub includes everything needed to service and maintain every feature and appliance in your home today and for years to come. HomeHub includes home documents, home inventory, scheduled maintenance reminders, how-to videos, and service request notifications.
            </div>
          </div>
          <div className='col-lg-7'>
            <Vimeo video='https://vimeo.com/584372160' style={{textAlign: 'center'}}/>
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-12'>
            <div className='intro-header'>Service Management Links</div>
          </div>
          <div className='col-xs-12'>
            <div className='row' style={{backgroundColor: '#eee', padding: '20px 10px', marginTop: '20px', marginLeft: 0, marginRight: 0}}>
              <div className='col-sm-6 col-md-3'>
                <div className='intro-header-sub-center'>
                  <Link to={this.state.rfsUrl}>
                    <img className='intro-icon' src={req_service_icon} />
                  </Link>
                  <div>Request Service</div></div>
                <div className='intro-content'>This request relates to your builder warranty. Upload your images to allow our service representatives to expedite the process.</div>
              </div>
              <div className='col-sm-6 col-md-3'>
                <div className='intro-header-sub-center'>
                  <Link to='/home-hub?tab=home-documents'>
                    <img className='intro-icon' src={home_docs_icon} />
                  </Link>
                  <div>Home Documents</div></div>
                <div className='intro-content'>Click the link to review your home owner's manual and other documents pertaining to your home.<div>&nbsp;</div></div>
              </div>
              <div className='col-sm-6 col-md-3'>
                <div className='intro-header-sub-center'>
                  <Link to='/home-hub?tab=home-inventory'>
                    <img className='intro-icon' src={home_inventory_icon} />
                  </Link>
                  <div>Home Inventory</div>
                </div>
                <div className='intro-content'>Click the link to access your installed manufactured products and warranties. Be sure to register them using your purchase date.</div>
              </div>
              <div className='col-sm-6 col-md-3'>
                <div className='intro-header-sub-center'>
                  <Link to='/home-hub?tab=home-maintenance'>
                    <img className='intro-icon' src={home_maintenance_icon} />
                  </Link>
                  <div>Home Maintenance</div></div>
                <div className='intro-content'>Click to access your monthly maintenance notifications and check off when they are completed.</div>
              </div>
            </div>
          </div>
        </div>
        <div className='row' style={{marginTop: '30px'}}>
          <div className='col-xs-12'>
            <div className='intro-header'>Maintenance and Tricks of The Trade</div>
            <div className='row background-box'>
              <div className='col-xs-4'>
                <div className='sub-text-container'>
                  <img className='sub-logo' src='/images/logo_30.png'/>
                  <div className='sub-title'>How-to Videos for Home & Property Maintenance</div>
                  <div className='sub-content'>Now and then, you may notice things around your home that need repair. Here are some videos to show you how to take care of some of your home's most basic needs.</div>
                  <div style={{marginTop: '1em', fontSize: '1em'}}><a href='https://vimeo.com/showcase/8718068' target='_blank' >learn more...</a></div>
                </div>
              </div>
              <div className='col-xs-4'>

                <div className='sub-image-container'>
                  <div className='sub-image-header' >How to charge the battery in your smoke dectector</div>
                  <img className='sub-image' src='/images/4.png' /></div>
                <div className='sub-image-container' style={{marginTop: '30px'}}>
                  <div className='sub-image-header' >How to shut off the gas in case of emergency</div>
                  <img className='sub-image' src='/images/1.png' />
                  <div style={{marginTop: '1em', fontSize: '1em'}}><a href='https://vimeo.com/showcase/8718068' target='_blank' >and more...</a></div>
                </div>

              </div>
              <div className='col-xs-4'>
                <div className='sub-image-container'>
                  <div className='sub-image-header' >How to reset an appliance at your breaker subpannel</div>
                  <img className='sub-image' src='/images/2.png' />
                </div>

                <div className='sub-image-container' style={{marginTop: '30px'}}>
                  <div className='sub-image-header' >How to clear your in sink disposal</div>
                  <img className='sub-image' src='/images/3.png' />
                </div>
              </div>
            </div>

            <div style={{marginTop: '20px'}}>
              <div className='pull-left'>{'Contact us at '}
                <a href='mailto:support@siteoneservices.com'>
                    support@siteoneservices.com</a>
              </div>
              <div className='pull-right'>Copyright 2021 by SiteOne Services</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    homeownerLots: state.LotStore.HomeownerLots
  };
};

export default withRouter(connect(mapStateToProps)(HomeownerIntro));



// WEBPACK FOOTER //
// ./src/portal_homeowner/intro.js